/* EMPAREJAR LA PRENDA ENTRE DOS PÁGINAS · 27-ago-2026
 * El porqué visual está en `avora-transicion.css`.
 *
 * 🔴 LO ÚNICO QUE HACE ESTE ARCHIVO ES PONER UN NOMBRE. La animación entera la
 * hace el navegador: si dos páginas tienen un elemento con el mismo
 * `view-transition-name`, lo trata como el MISMO objeto y lo mueve de una
 * posición a la otra. No hay que calcular nada ni dibujar nada.
 *
 * 🔴 UNO A LA VEZ, Y SE MIDE EN EL ÚLTIMO MOMENTO. Un nombre tiene que ser
 * único en el documento, así que no se puede marcar las 54 tarjetas del
 * catálogo. Se marca la que corresponde al viaje que está a punto de ocurrir,
 * usando los dos eventos que el navegador da justo para esto:
 *   · `pageswap`   — en la página que se VA, sabiendo ya a dónde vamos.
 *   · `pagereveal` — en la que LLEGA, sabiendo de dónde venimos.
 * Las dos veces la pregunta es la misma: "¿qué elemento de ESTA página
 * representa a ese producto?". En el catálogo es su tarjeta; en la ficha es la
 * foto grande.
 *
 * 🔴 Y SI NO HAY PAREJA, NO PASA NADA MALO. Ir de la portada al carrito, o de
 * una ficha a otra sin catálogo de por medio, simplemente no encuentra elemento
 * que marcar y queda el fundido del fondo. La transición nunca depende de que
 * la pareja exista.
 */
(function () {
  'use strict';

  /* Sin soporte no hay nada que preparar: el CSS ya se ignoró solo. */
  if (typeof document.startViewTransition !== 'function') return;
  if (typeof window.navigation === 'undefined') return;

  var NOMBRE = 'prenda';

  /* El identificador de un producto es su `handle`, que va en la ruta. Se saca
     de la ruta y no del parámetro porque los enlaces del catálogo llevan
     `/collections/x/products/y` —el `within:` que da la miga de pan— y el de la
     ficha va sin colección: la ruta cambia, el handle no. */
  function handleDe(url) {
    if (!url) return null;
    try {
      var m = new URL(url, location.href).pathname.match(/\/products\/([^\/?#]+)/);
      return m ? m[1] : null;
    } catch (e) { return null; }
  }

  /* 🔴 EL PRODUCTO DEL VIAJE ESTÁ EN UNO DE LOS DOS EXTREMOS, NO SIEMPRE EN EL
     MISMO. Aquí estuvo el fallo de la primera versión: al LLEGAR se preguntaba
     por el producto de la URL de ORIGEN, y viniendo del catálogo esa URL no
     tiene ninguno. La ficha no nombraba su foto, no había pareja y no había
     transformación — con la transición corriendo igual, así que no fallaba
     nada a la vista: simplemente no pasaba el efecto. Medido el 27-ago:
     `marcado: null` al aterrizar.
     Yendo, el producto está en el destino; volviendo, en el origen. La pregunta
     correcta es "¿cuál de los dos extremos es una ficha?".

     ⚠️ Y si los DOS lo son y son distintos, no hay pareja a propósito: emparejar
     dos prendas distintas haría que una se transformara en la otra, que es
     exactamente la mentira que este efecto no debe contar. */
  function handleDelViaje(desde, hacia) {
    var a = handleDe(desde), b = handleDe(hacia);
    if (a && b) return a === b ? a : null;
    return a || b;
  }

  function limpia() {
    var previo = document.querySelector('[data-vt]');
    if (previo) {
      previo.style.viewTransitionName = '';
      previo.removeAttribute('data-vt');
    }
  }

  function marca(el) {
    limpia();
    if (!el) return;
    el.style.viewTransitionName = NOMBRE;
    el.setAttribute('data-vt', '');
  }

  /* Qué elemento de ESTA página es ese producto. */
  function representa(handle) {
    if (!handle) return null;

    /* En la ficha: la foto grande — pero solo si la ficha es la de ESE
       producto. Sin esta comprobación, ir de una ficha a otra emparejaría dos
       prendas distintas y una se transformaría en la otra. */
    if (handleDe(location.href) === handle) {
      /* 🔴 TIENE QUE SER UNA FOTO QUE SE ESTÉ VIENDO. Un `view-transition-name`
         sobre un elemento con `display:none` no cancela la transición: el
         navegador retrata una caja VACÍA y la anima igual. Eso era el
         RECTÁNGULO BLANCO que aparecía al salir de una ficha hacia la portada.

         El selector decía `:not([data-oculta])`, que era el atributo del guion
         de color RETIRADO el 27-ago (ver la nota en `layout/theme.liquid`). El
         filtro vivo, en `avora-ficha.js`, esconde con **`data-fuera`** — así que
         la condición no excluía nada y con un color elegido se nombraba la
         primera foto de la galería aunque estuviera apagada.

         Se comprueba además `offsetParent`: cubre cualquier otra forma de
         esconder que aparezca después sin que haya que acordarse de este
         archivo. Si no hay ninguna visible, se devuelve null y queda el fundido
         de siempre — que es el comportamiento correcto, no un fallo. */
      var fotos = document.querySelectorAll('.f-galeria__foto:not([data-fuera]) img');
      for (var i = 0; i < fotos.length; i++) {
        if (fotos[i].offsetParent !== null) return fotos[i];
      }
    }

    /* En un listado: la foto de su tarjeta. `CSS.escape` porque un handle puede
       traer caracteres que rompan el selector. */
    var enlace = document.querySelector(
      '.p-pieza a[href*="/products/' + CSS.escape(handle) + '"]');
    return enlace ? enlace.querySelector('.p-pieza__foto') : null;
  }

  /* 🔴 UN VIAJE NECESITA LOS DOS EXTREMOS. Aquí estaba el CUADRO BLANCO que
     salía al ir de una ficha a la PORTADA.

     Al irnos se nombraba la foto siempre que alguno de los dos extremos fuera
     una ficha — y la portada no lleva las 54 prendas, así que al aterrizar no
     había pareja. Un `old` sin `new` no es inofensivo con este CSS: como
     `::view-transition-old(prenda)` tiene `animation: none` —puesto a propósito
     para que no se vea el doble contorno cuando SÍ hay pareja—, la capa suelta
     no se funde y queda encima de la portada como una caja vacía.

     La regla: sólo se nombra si el destino puede enseñar ESA prenda. O es otra
     vista de la misma ficha, o es un listado donde su tarjeta existe. La
     portada, la bolsa y las páginas sueltas no lo son: ahí no hay viaje que
     contar y queda el fundido normal, que es lo correcto. */
  function destinoPuedeMostrar(handle, destino) {
    if (!handle || !destino) return false;
    if (handleDe(destino) === handle) return true;
    try {
      return /^\/(collections|search)(\/|$)/.test(new URL(destino, location.href).pathname);
    } catch (e) { return false; }
  }

  /* Nos vamos: el viaje va de aquí al destino. */
  addEventListener('pageswap', function (e) {
    if (!e.viewTransition) return;
    var destino = e.activation && e.activation.entry && e.activation.entry.url;
    var handle = handleDelViaje(location.href, destino);
    if (!destinoPuedeMostrar(handle, destino)) { limpia(); return; }
    marca(representa(handle));
  });

  /* Llegamos: el viaje venía de allá hasta aquí. */
  addEventListener('pagereveal', function (e) {
    if (!e.viewTransition) return;

    var act = navigation.activation;
    var desde = act && act.from && act.from.url;
    /* Misma regla que al salir, con los extremos al revés: si de donde veníamos
       no podía enseñar esta prenda, no hubo pareja allá y aquí no se nombra
       nada. Una capa suelta al llegar es menos visible que al salir —es la foto
       de verdad, en su sitio— pero se descarta igual: la mitad de un viaje no
       es un viaje. */
    var handle = handleDelViaje(desde, location.href);
    if (!destinoPuedeMostrar(handle, desde)) { limpia(); }
    else { marca(representa(handle)); }

    /* `traverse` es el botón de atrás y el gesto de deslizar del iPhone. Es lo
       que invierte la dirección del fundido (ver el CSS). */
    var raiz = document.documentElement;
    raiz.setAttribute('data-vt-dir',
      act && act.navigationType === 'traverse' ? 'atras' : 'adelante');

    /* Al terminar se quita todo: un `view-transition-name` olvidado sobre una
       foto la saca de su capa de pintado y puede cambiar cómo se apila con el
       resto de la página. */
    e.viewTransition.finished.then(function () {
      limpia();
      raiz.removeAttribute('data-vt-dir');
    }, function () { limpia(); });
  });
})();
